import React from 'react';
import { ArrowUpRight, Phone } from 'lucide-react';
import { useIdioma } from '../../i18n/idioma';

const ACADEMY = [
    { clave: 'lp.pie.a1', url: 'https://www.razaperronaacademy.com' },
    { clave: 'lp.pie.a2', url: 'https://www.razaperronaacademy.com/category/all-products' },
    { clave: 'lp.pie.a3', url: 'https://dechalanaempresario.com/landing' },
    { clave: 'lp.pie.a4', url: 'https://www.razaperronaacademy.com/elyarderoperron' },
] as const;

const TELEFONOS = [
    { label: '+1 (480) 670-0484', url: 'https://wa.me/14806700484' },
    { label: '+1 (480) 749-3537', url: 'https://wa.me/14807493537' },
];

const PieDePagina: React.FC = () => {
  const { t } = useIdioma();
  return (
    <footer className="rp-on-light border-t border-acero-200 bg-white px-5 py-14 sm:px-8">
        <div className="mx-auto max-w-[1240px]">
            <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <div className="flex items-center gap-2.5">
                        <img src="/logo.webp" alt="" className="h-8 w-auto object-contain" />
                        <span className="text-[15px] font-bold tracking-tight text-navy-950">
                            Raza Pro
                        </span>
                    </div>
                    <p className="mt-4 max-w-[34ch] text-[15px] leading-relaxed text-acero-700">
                        {t('lp.pie.descripcion')}
                    </p>
                </div>

                <nav aria-label="Raza Perrona Academy" className="lg:col-span-4">
                    <h2 className="text-[13px] font-bold tracking-tight text-navy-950">
                        {t('lp.pie.academy')}
                    </h2>
                    <ul className="mt-4 space-y-2.5">
                        {ACADEMY.map((l) => (
                            <li key={l.url}>
                                <a
                                    href={l.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group inline-flex items-center gap-1.5 rounded-lg text-[15px] text-acero-700 transition-colors hover:text-navy-950"
                                >
                                    {t(l.clave)}
                                    <ArrowUpRight
                                        aria-hidden="true"
                                        className="h-3.5 w-3.5 text-acero-400 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                                    />
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="lg:col-span-3">
                    <h2 className="text-[13px] font-bold tracking-tight text-navy-950">
                        {t('lp.pie.contacto')}
                    </h2>
                    <ul className="mt-4 space-y-2.5">
                        {TELEFONOS.map((t) => (
                            <li key={t.url}>
                                <a
                                    href={t.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 rounded-lg text-[15px] text-acero-700 transition-colors hover:text-navy-950"
                                >
                                    <Phone className="h-3.5 w-3.5 text-acero-400" aria-hidden="true" />
                                    {t.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-acero-200 pt-6 sm:flex-row sm:items-center">
                <p className="text-[13px] text-acero-600">
                    {t('lp.pie.derechos', { anio: new Date().getFullYear() })}
                </p>
                <a
                    href="https://www.razaperronaacademy.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 rounded-lg text-[13px] text-acero-600 transition-colors hover:text-navy-950"
                >
                    razaperronaacademy.com
                    <ArrowUpRight className="h-3 w-3" aria-hidden="true" />
                </a>
            </div>
        </div>
    </footer>
  );
};

export default PieDePagina;
